/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const DAM_DATA_IDS = {};

export const FILE_EXPLORER_DATA_IDS = {
  breadcrumbLink: 'File Explorer: Breadcrumb Link',
  breadcrumbLinkRoot: 'File Explorer: Breadcrumb Link root',
};
